export default () => Component(function ($context) {
	return $context.select('.product-reviews');
}, function ($reviews, self) {
	var filter_rate = null;
	var src_header = null;
	const $reviewAddBtn = $reviews.find('.product-reviews__add-review-btn');
	$reviews.data('component', self);

	$.extend(self, {
		initEventListeners: function () {
			$(document).on('review_added', self.handleReviewAdd);

			$reviews.on('filter', '.product-reviews-overview', function (e, rate) {
				self.filterByRate(rate);
			});

			$reviews.on('reset', '.product-reviews-overview', function () {
				self.resetFilter();
			});

			$reviewAddBtn.on('click', function () {
				self.openForm();
			});

			$reviews.on('click', '.product-reviews__m-overview', function () {
				const template = $(this).data('template');

				ModalUtil.openContent($(template));
			});

			$reviews.on('click', '.product-reviews__more-toggler', function () {
				var $btn = $(this);

				$reviews.find('.product-reviews__review_hidden').toggle();

				$btn.find('span').toggle();
			});
		},
		openForm: function () {
			const currentDocumentPos = $('body, html').scrollTop();
			if (ResponsiveUtil.isToTablet()) {
				$('body, html').scrollTop(0);
			}
			ModalUtil.openContent(window.product_review_form, null, function() {
				if (ResponsiveUtil.isToTablet()) {
					$('body, html').scrollTop(currentDocumentPos);
				}
			}, {
				enableEscapeKey: false
			});
		},
		destruct: function () {
			$(document).off('review_added', self.handleReviewAdd);
		},
		handleReviewAdd: function (e, data) {
			var $review = $('<div class="product-reviews__review"></div>');
			$review.append(data.html);

			$reviews.find('.product-reviews__reviews').prepend($review);
			self.updateCount();
			self.updateInfo();
			self.updateFilter();
			Update($reviews);
		},
		filterByRate: function (rate) {
			filter_rate = rate;
			self.setHeader('Отзывы с оценкой ' + rate);
			self.updateFilter();
		},
		resetFilter: function () {
			filter_rate = null;
			self.resetHeader();
			self.updateFilter();
		},
		updateFilter: function () {
			var $all_reviews = $reviews.find('.product-review').not('.product-review_reply').closest(
				'.product-reviews__review');
			$all_reviews.removeClass('product-reviews__review_filtered');

			if (filter_rate) {
				var $hidden_reviews = $reviews.find(
					'.product-review:not(.product-review_reply):not(.product-review_rate_' + filter_rate + ')').closest(
					'.product-reviews__review');
				$hidden_reviews.addClass('product-reviews__review_filtered');
			}

			self.updateHidden();
		},
		updateHidden: function () {
			var $all_reviews = $reviews.find('.product-review').not('.product-review_reply').closest(
				'.product-reviews__review');
			$all_reviews.removeClass('product-reviews__review_hidden');

			var $hidden_reviews = $all_reviews.not('.product-reviews__review_filtered').slice(5);
			$hidden_reviews.addClass('product-reviews__review_hidden');

			$reviews.toggleClass('product-reviews--has-hidden', $hidden_reviews.length > 0);
		},
		updateInfo: function () {
			$.ajax({
				url: ''
			}).then(function (response) {
				$reviews.find('.product-reviews__summary-container').replaceWith(
					$(response).find('.product-reviews__summary-container').eq(0));

				Update($reviews);
			});
		},
		updateCount: function () {
			var count = $reviews.find('.product-reviews__review').length;
			$reviews.toggleClass('product-reviews_empty', count === 0);
			$reviews.find('.product-reviews__count').text(count);
		},
		setHeader: function (header) {
			var $header = $reviews.find('.product-reviews__header');

			if (!src_header) {
				src_header = $header.html();
			}

			$header.html(header);
		},
		resetHeader: function () {
			var $header = $reviews.find('.product-reviews__header');

			if (src_header) {
				$header.html(src_header);
				src_header = null;
				self.updateCount();
			}
		}
	});

	self.initEventListeners();
});



